var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('svg',{attrs:{"id":"svg1","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }